import {useEffect, useState} from "react";
import {
  Link
} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const Footer = () =>{
	const [activateBtn, setActivateBtn] = useState(false)
	  useEffect(() => {
	    const onScroll = e => {
	    	
	    	if ( e.target.documentElement.scrollTop > 250 ) {
	    		setActivateBtn(true);
	    	}else{
	    		setActivateBtn(false)
	    	}
	    };
	    window.addEventListener("scroll", onScroll);

	    return () => window.removeEventListener("scroll", onScroll);
	  }, []);


	  function onChangeRecaptcha(value){
		  //console.log("Captcha value:", value);
		}


	return(
		<footer className="footer">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-4 text-center text-lg-start mb-4 mb-lg-0">
					
						<Link to="/">
							<img src="assets/images/footer-logo.png" className="img-fluid" alt="" />
						</Link>
						
					</div>
					<div className="col-lg-4 mb-4 mb-lg-0">
						<ul className="socialList d-flex align-items-center justify-content-center">
							<li>
								<a target="_blank" href="https://www.linkedin.com/company/klizo-solutions/">
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3.56524 5.02307H0.814484V13.9146H3.56524V5.02307Z" fill="white"/>
									<path d="M2.17693 3.86093C3.07448 3.86093 3.80414 3.12481 3.80414 2.22081C3.80414 1.31681 3.07448 0.580688 2.17693 0.580688C1.27939 0.580688 0.549728 1.31681 0.549728 2.22081C0.549728 3.12481 1.27939 3.86093 2.17693 3.86093Z" fill="white"/>
									<path d="M7.96902 9.25249C7.96902 7.9998 8.5437 7.25722 9.64788 7.25722C10.6617 7.25722 11.1459 7.97397 11.1459 9.25249V13.921H13.8838V8.29037C13.8838 5.90768 12.5342 4.7583 10.6487 4.7583C8.76325 4.7583 7.96902 6.23053 7.96902 6.23053V5.0295H5.32803V13.921H7.96902V9.25249Z" fill="white"/>
									</svg>
								</a>
							</li>
							<li>
								<a target="_blank" href="https://www.instagram.com/klizosolutions/">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M8.21997 2.02064C10.17 2.02064 10.396 2.0271 11.1644 2.06584C11.8747 2.09813 12.2622 2.21436 12.5204 2.31767C12.8627 2.44682 13.1016 2.60825 13.3599 2.86008C13.6182 3.11836 13.7731 3.35728 13.9023 3.69951C13.9991 3.95779 14.1218 4.34522 14.1541 5.05551C14.1864 5.82392 14.1993 6.05637 14.1993 7.99998C14.1993 9.94359 14.1928 10.176 14.1541 10.9445C14.1218 11.6547 14.0056 12.0422 13.9023 12.3005C13.7731 12.6427 13.6117 12.8816 13.3599 13.1399C13.108 13.3982 12.8627 13.5531 12.5204 13.6823C12.2622 13.7791 11.8747 13.9018 11.1644 13.9341C10.396 13.9664 10.1636 13.9793 8.21997 13.9793C6.27636 13.9793 6.0439 13.9729 5.2755 13.9341C4.56521 13.9018 4.17778 13.7856 3.91949 13.6823C3.57726 13.5531 3.33835 13.3917 3.08006 13.1399C2.82177 12.8816 2.6668 12.6427 2.53766 12.3005C2.4408 12.0422 2.31812 11.6547 2.28583 10.9445C2.25354 10.176 2.24063 9.94359 2.24063 7.99998C2.24063 6.05637 2.24709 5.82392 2.28583 5.05551C2.31812 4.34522 2.43434 3.95779 2.53766 3.69951C2.6668 3.35728 2.82823 3.11836 3.08006 2.86008C3.33835 2.60179 3.57726 2.44682 3.91949 2.31767C4.17778 2.22082 4.56521 2.09813 5.2755 2.06584C6.0439 2.03356 6.27636 2.02064 8.21997 2.02064ZM8.21997 0.709839C6.23762 0.709839 5.99225 0.716296 5.21093 0.755039C4.43607 0.787325 3.90658 0.916468 3.44166 1.09727C2.96383 1.28453 2.55703 1.5299 2.15023 1.9367C1.74343 2.3435 1.49806 2.7503 1.3108 3.22813C1.13 3.69305 1.00731 4.22254 0.975025 4.9974C0.936282 5.77226 0.929825 6.02409 0.929825 8.00644C0.929825 9.98879 0.936282 10.2342 0.975025 11.0155C1.00731 11.7903 1.13645 12.3198 1.3108 12.7847C1.49806 13.2626 1.74343 13.6694 2.15023 14.0762C2.55703 14.483 2.96383 14.7284 3.44166 14.9156C3.90658 15.0964 4.43607 15.2191 5.21093 15.2578C5.98579 15.2901 6.23762 15.303 8.21997 15.303C10.2023 15.303 10.4477 15.2966 11.229 15.2578C12.0039 15.2256 12.5334 15.0964 12.9983 14.9156C13.4761 14.7284 13.8829 14.483 14.2897 14.0762C14.6965 13.6694 14.9419 13.2626 15.1291 12.7847C15.3099 12.3198 15.4326 11.7903 15.4649 11.0155C15.4972 10.2406 15.5101 9.98879 15.5101 8.00644C15.5101 6.02409 15.5037 5.77872 15.4649 4.9974C15.4326 4.22254 15.3035 3.69305 15.1291 3.22813C14.9419 2.7503 14.6965 2.3435 14.2897 1.9367C13.8829 1.5299 13.4761 1.28453 12.9983 1.09727C12.5334 0.916468 12.0039 0.793782 11.229 0.755039C10.4541 0.722753 10.2023 0.709839 8.21997 0.709839Z" fill="white"/>
									<path d="M8.21997 4.25488C6.15367 4.25488 4.47481 5.93375 4.47481 8.00004C4.47481 10.0663 6.15367 11.7452 8.21997 11.7452C10.2863 11.7452 11.9651 10.0663 11.9651 8.00004C11.9651 5.93375 10.2863 4.25488 8.21997 4.25488ZM8.21997 10.4279C6.87687 10.4279 5.79207 9.33667 5.79207 8.00004C5.79207 6.66341 6.88333 5.57215 8.21997 5.57215C9.5566 5.57215 10.6479 6.66341 10.6479 8.00004C10.6479 9.33667 9.5566 10.4279 8.21997 10.4279Z" fill="white"/>
									<path d="M12.9854 4.10632C12.9854 4.59061 12.5915 4.9845 12.1072 4.9845C11.6229 4.9845 11.229 4.59061 11.229 4.10632C11.229 3.62204 11.6229 3.22815 12.1072 3.22815C12.5915 3.22815 12.9854 3.62204 12.9854 4.10632Z" fill="white"/>
									</svg>
								</a>
							</li>

							<li><a href="https://twitter.com/KlizoSolutions" target="_blank" rel="noreferrer"><svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.130038 10.2759C1.41501 11.1024 2.94536 11.5803 4.58548 11.5803C9.98368 11.5803 13.0315 7.0215 12.8507 2.92765C13.4189 2.52085 13.9096 2.00428 14.3035 1.42313C13.7805 1.65559 13.2187 1.81056 12.6311 1.88159C13.2316 1.51999 13.6901 0.951758 13.9096 0.273755C13.3479 0.609528 12.728 0.848443 12.0629 0.977586C11.5334 0.409355 10.7779 0.0606689 9.93847 0.0606689C8.05944 0.0606689 6.68406 1.81056 7.10378 3.63148C4.6888 3.5088 2.54502 2.35296 1.11153 0.590157C0.349582 1.89451 0.71764 3.60565 2.00907 4.47092C1.53124 4.458 1.0857 4.3224 0.691812 4.10931C0.659526 5.45886 1.6281 6.71801 3.02285 6.99567C2.61605 7.10544 2.16405 7.13127 1.71204 7.04733C2.0801 8.20316 3.15845 9.04259 4.43051 9.06842C3.21011 10.0241 1.66684 10.4567 0.123581 10.2695L0.130038 10.2759Z" fill="white"></path></svg></a>
							</li>

							
							
							<li>
								<a target="_blank" href="https://www.facebook.com/KlizoSolutions">
									<svg width="8" height="17" viewBox="0 0 8 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1.7895 16.1382H5.02454V8.02797H7.28454L7.52346 5.31596H5.02454V3.7727C5.02454 3.13344 5.15368 2.88161 5.77357 2.88161H7.52346V0.0662842H5.28282C2.8743 0.0662842 1.7895 1.12526 1.7895 3.15927V5.32242H0.104176V8.07317H1.7895V16.1446V16.1382Z" fill="white"/>
									</svg>
								</a>
							</li>
						</ul>
					</div>
					<div className="col-lg-4 text-center text-lg-end text-white">
						<p className="mb-0 copyRightText">&copy; 2022 Klizo Solutions Pvt. Ltd.</p>
					</div>
				</div>
			</div>
			<button role="none" type="button" className={`scrollTopBtn ${activateBtn && 'active'}`} onClick={ ()=>{ window.scrollTo({
      top: 0,
      behavior: 'smooth'
    }) } }>
				<img src="assets/images/top-arrow.png" className="img-fluid" alt="" />
			</button>

			<ReCAPTCHA
			    sitekey="6LfzT84iAAAAAP9G77B8IcmvgeEwPKB9EhbhR5eY"
			    size="invisible"
			    onChange={onChangeRecaptcha}
			  />
		</footer>


		
	)
}

export default Footer;